<template>
    <div class="batch-export-size-img-page">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <div class="section-gap">
            <el-dropdown size="small" type="primary" class="margin-right">
              <el-button size="small" type="primary">
                导入表格<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <div class="file-btn" :class="{'is-loading': loading}">导入表格
                    <input type="file" name="xlfile" id="xlf1" @change="fileChange($event, 1)"/>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div class="file-btn" :class="{'is-loading': loading}">导入时装周表格
                    <input type="file" name="xlfile" id="xlf2" @change="fileChange($event, 2)"/>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            
            <button class="button is-success margin-right" @click="createImage" :class="{'is-loading':isCreateing}">生成图片</button>
            <a target="_blank" class="button" href="https://dn-testimage.qbox.me/ai-admin/3d153cb9f36e36463280ed357ac4e8e5.xlsx">下载模板</a>
          </div>
        </article>
      </div>
      <div class="preview-container">
        <div v-if="uploadType == 1" style="display: flex;">
          <p class="title">效果预览</p>
          <div v-for="(item, index) in tableList" :key="index">
            <span class="item-tag" :class="{'selected': currentModel.id == item.id}" @click="select(item)">{{item.name}}</span>
          </div>
        </div>
        <template v-if="uploadType == 1" >
          <div v-for="(item, key) in list" class="clearfix size-img-swap" :key="key">
            <p class="size-id">ID：{{key}}</p>
            <div class="size-img js_size_img" :data-id="key">
              <div><image-component :image="currentModel.goodsPic" :width="750"></image-component></div>
              <div v-if="newPropList.length" class="new-props-swap">
                <div class="color-swap" v-if="colorList.length">
                  <span class="props-title">颜色</span>
                  <div class="color-item-swap">
                    <span class="prop-item">/color</span>
                    <span class="prop-item" v-for="(colorItem, colorKey) in item.colors" v-if="colorKey !== 'ID'" :key="colorKey">{{colorItem}}</span>
                  </div>
                </div>
                <div class="color-swap">
                  <span class="props-title">面料</span>
                  <div class="color-item-swap">
                    <span class="prop-item">/fabrics</span>
                    <span class="prop-item">{{item.props['面料']}}</span>
                  </div>
                </div>
                <div class="props-group clearfix">
                  <div class="prop" :class="{'margin-bottom-0': index == 2 || index == 3}" v-for="(propItem, index) in propsGroup" :key="index">
                    <span class="props-title">{{propItem.title}}</span>
                    <div class="prop-value-swap">
                      <div class="prop-value" v-for="(propValue, index) in propItem.list" :key="index">
                        <div v-if="item.props[propItem.title] == propValue" class="line"></div>
                        <span :class="{'active' : item.props[propItem.title] == propValue}">{{propValue}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="prop-tips" v-if="item.props && item.props.tips">
                  {{item.props.tips}}
                </div>
              </div>
              <ul class="props clearfix" v-else>
                <li class="prop-item" v-for="(propVal,propKey) in item.props" :key="propKey" v-if="propKey !== 'ID' && propKey !== 'tips'">
                  <span>{{propKey}}: {{propVal}}</span>
                </li>
                <li class="prop-tips" v-if="item.props && item.props.tips">{{item.props.tips}}</li>
              </ul>
              <div><image-component :image="currentModel.sizePic" :width="750"></image-component></div>
              <table>
                <thead>
                  <tr>
                    <td class="text-center t-header" v-for="(name, index) in getThead(item.sizes[0])" :key="index" v-if="name !== 'ID' && name !== 'tips'">{{name}}</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(rowItem, index) in item.sizes" :key="index">
                    <td class="text-center" v-for="(sizeVal,sizeKey) in rowItem" :key="sizeKey" v-if="sizeKey !== 'ID' && sizeKey !== 'tips'">{{sizeVal}}</td>
                  </tr>
                </tbody>
              </table>
              <p class="tfoot">(单位CM）</p>
              <p v-if="item.sizes.length && item.sizes[0].tips" class="size-tips">{{item.sizes[0].tips}}</p>
              <div v-if="item.tryReport && item.tryReport.length">
                <image-component :image="currentModel.tryPic" :width="750"></image-component>
              </div>
              <table v-if="item.tryReport && item.tryReport.length">
                <thead>
                  <tr>
                    <td class="text-center t-header" v-for="(name, index) in getThead(item.tryReport[0])" :key="index">{{name}}</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(rowItem, index) in item.tryReport" :key="index">
                    <td class="text-center" v-for="(sizeVal,sizeKey) in rowItem" :key="sizeKey" v-html="sizeVal"></td>
                  </tr>
                </tbody>
              </table>
              <p class="tfoot" v-if="item.tryReport && item.tryReport.length">(单位CM）</p>
              <p v-if="item.tryReport && item.tryReport.length && item.trySummary" class="size-tips">*{{item.trySummary}}</p>
            </div>
          </div>
        </template>
        <template v-else>
          <div v-for="(item, key) in list" class="clearfix size-img-swap" :key="key">
            <p class="size-id size-key">ID：{{key}}</p>
            <div class="size-img js_size_img new-size" :data-id="key">
              <div class="new-title">尺码信息</div>
              <table>
                <thead>
                  <tr>
                    <td class="text-center t-header" v-for="(name, index) in getThead(item.sizes[0])" :key="index" v-if="name !== 'ID' && name !== 'tips'">{{name}}</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(rowItem, index) in item.sizes" :key="index">
                    <td class="text-center" v-for="(sizeVal,sizeKey) in rowItem" :key="sizeKey" v-if="sizeKey !== 'ID' && sizeKey !== 'tips'">{{sizeVal}}</td>
                  </tr>
                </tbody>
              </table>
              <div class="new-title">成分</div>
              <div class="prop-item">{{item.props['面料']}}</div>
              <div class="new-title">护理</div>
              <p v-if="item.sizes.length && item.sizes[0].tips" class="prop-item">{{item.sizes[0].tips}}</p>
            </div>
          </div>
        </template>
      </div>
    </div>
</template>
<script type="text/babel">
  import XLSX from "xlsx"
  import domtoimage from 'dom-to-image'
  import JSZip from 'jszip'
  import fileSaver from 'file-saver'
  export default {
    data(){
      return {
        sizeList: [],
        oldPropList: [],
        newPropList: [],
        colorList: [],
        reportList: [],
        modelList: [],
        isCreateing:false,
		    propsGroup: [
          {
            title: '版型',
            list: ['宽松','适中','修身','紧身']
          },
          {
            title: '厚度',
            list: ['薄透','轻薄','适中','偏厚']
          },
          {
            title: '触感',
            list: ['轻软','适中','偏硬','硬挺']
          },
          {
          title: '弹性',
          list: ['无弹','微弹','弹力','高弹']
          }
        ],
        loading: false,
        tableList: [],
        currentModel: {
          id: '',
          name: '',
          goodsPic: '',
          sizePic: '',
          tryPic: ''
        },
        uploadType: 1
      }
    },
    computed: {
      list() {
        let result = {};
        let propList = []
        _.each(this.sizeList,item => {
          item.ID = item.ID.trim()
          if(!result[item.ID]){
            result[item.ID] = {}
            result[item.ID].sizes = []
            result[item.ID].sizes.push(item)
          } else {
            result[item.ID].sizes.push(item)
          }
        })
        if(this.newPropList.length) {
          propList = this.newPropList
        } else {
          propList = this.oldPropList
        }
        _.each(propList,item => {
          for(let k in item) {
            item[k] = item[k].trim()
          }
          if(!result[item.ID]) {
            result[item.ID] = {}
            result[item.ID].props = item
          } else {
            result[item.ID].props = item
          }
        })
        _.each(this.colorList, item => {
          item.ID = item.ID.trim()
          if(!result[item.ID]) {
          result[item.ID] = {}
          result[item.ID].colors = item
          } else {
          result[item.ID].colors = item
          }
        })
        if (this.reportList.length && this.modelList.length) {
          _.each(this.reportList, item => {
            item.ID = item.ID.trim()
            if(!result[item.ID]) {
              result[item.ID] = {}
            }
            if (!result[item.ID].reportList) {
              result[item.ID].reportList = []
              result[item.ID].trySummary = item['试穿总结']
              result[item.ID].reportList.push(item)
            } else {
              result[item.ID].reportList.push(item)
            }
            if (!result[item.ID].tryReport) {
              result[item.ID].tryReport = []
            }
          })
          for (const key in result) {
            const trySize = result[key].reportList.map(report => {
              return {
                '试穿人': report['试穿人'] || '',
                '试穿尺码': report['试穿尺码'] || ''
              }
            })
            let isSameSize = true
            for (let i = 0; i < trySize.length; i++) {
              const element = trySize[i]
              const sameSize = this.modelList.filter(model => {
                if (element['试穿人'].trim() == model['试穿人'].trim() && element['试穿尺码'] != model['日常穿着尺码']) {
                  return model
                }
              })
              if (sameSize.length) {
                isSameSize = false
                break
              }
            }
            let temp = ['试穿人', '身高/体重', '三围', '试穿尺码', '试穿体验']
            if (!isSameSize) {
              temp = ['试穿人', '身高/体重', '三围', '试穿/日常', '试穿体验']
            }
            result[key].reportList.forEach(report => {
              let tempReport = {}
              if (report['试穿人']) {
                tempReport['试穿人'] = report['试穿人']
              }
              for (let i = 0; i < this.modelList.length; i++) {
                const model = this.modelList[i];
                if (tempReport['试穿人'] && tempReport['试穿人'].trim() == model['试穿人'].trim()) {
                  tempReport['身高/体重'] = model['身高/体重']
                  tempReport['三围'] = `${model['胸围']}/${model['腰围']}/${model['臀围']}`
                  if (!isSameSize) {
                    tempReport['试穿/日常'] = report['试穿尺码'] == model['日常穿着尺码'] ? `${report['试穿尺码']}/${model['日常穿着尺码']}` : `${report['试穿尺码']}/<span style="color: #e8912d;">${model['日常穿着尺码']}</span>`
                  } else {
                    tempReport['试穿尺码'] = report['试穿尺码']
                  }
                  break
                }
              }
              if (report['试穿体验']) {
                tempReport['试穿体验'] = report['试穿体验']
              }
              if(Object.keys(tempReport).length) {
                result[key].tryReport.push(tempReport)
              }
            })
          }
        }
        console.log(result)
        if (Object.keys(result).length) {
          this.loading = false
        }
        return result
      }
    },
    mounted() {
      this.getList()
    },
    methods: {
      select(row) {
        this.currentModel = Object.assign({}, this.currentModel, row)
      },
      getList() {
        HttpRequest.get('/admin.php?method=goods.getSizePicList').then(res => {
          this.tableList = _.toArray(res.data.list)
          this.currentModel = this.tableList[0]
        })
      },
      fileChange(e, type) {
        let files = e.target.files
        this.uploadType = type
        this.readFile(files[0]);
        setTimeout(() => {
          let file = type == 1 ? document.getElementById('xlf1') : document.getElementById('xlf2')
          file.value = ''
        }, 1000)
      },
      readFile(file){
        this.loading = true
        var reader = new FileReader();
        reader.onload = (e) => {
          var data = e.target.result;
          var wb = XLSX.read(data, { type: "binary" });
          if (this.uploadType == 1) {
            this.parseToJSON(wb)
          } else {
            this.parseToJSONTwo(wb)
            console.log(wb)
          }
        };
        reader.readAsBinaryString(file);
      },
      parseToJSONTwo(workbook) {
        let result = {};
        workbook.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
          if(roa.length) result[sheetName] = roa;
        });
        console.log(result)
        this.sizeList = result.size ? result.size : []
        this.newPropList = result.props1 ? result.props1 : []
      },
      parseToJSON(workbook){
        let result = {};
        workbook.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
          if(roa.length) result[sheetName] = roa;
        });
        this.sizeList = result.size ? result.size : []
        this.oldPropList = result.props0 ? result.props0 : []
        this.newPropList = result.props1 ? result.props1 : []
        this.colorList = result.color ? result.color : []
        this.reportList = result.report ? result.report : []
        this.modelList = result.model ? result.model : []
        if(!this.sizeList.length || (!this.oldPropList.length && !this.newPropList.length)){
          this.$message("请上传正确的表格~")
          this.loading = false
          return false
        }
        //检查必填项
        if(this.newPropList.length){
          let temp = ['面料','版型','厚度','触感','弹性']
          for(let i = 0, len = this.newPropList.length; i < len; i++){
            for(let j = 0, len2 = temp.length; j < len2; j++){
              if(!this.newPropList[i][temp[j]]){
                this.$message(`ID为${this.newPropList[i].ID}的属性：【${temp[j]}】没有填写完整~请填写完整后再进行上传`, 5000)
                this.sizeList = []
                this.oldPropList = []
                this.newPropList = []
                this.colorList = []
                this.reportList = []
                this.modelList = []
                this.loading = false
                return false
              }
            }
          }
        }
        if (this.reportList.length) {
          for (let i = 0; i < this.reportList.length; i++) {
            const element = this.reportList[i]
            if (element['试穿体验'] && element['试穿体验'].length > 10) {
              this.$message(`ID为${element.ID}的试穿体验字数不能超过10个字，请重新上传`, 5000)
              this.sizeList = []
              this.oldPropList = []
              this.newPropList = []
              this.colorList = []
              this.reportList = []
              this.modelList = []
              this.loading = false
              return false
            }
          }
        }
        this.loading = false
      },
      getThead(obj){
        return Object.keys(obj)
      },
      createImage(){
        let $doms = $('.js_size_img'),
            images = [];
        if(!$doms.length){
          this.$message("请先上传表格")
          return false
        }
        this.isCreateing = true
         _.each($doms,item => {
          let id = $(item).attr("data-id")
          domtoimage.toBlob(item).then((blob) => {
              images.push({
                blob: blob,
                name:`${id}.png`
              })
              if(images.length == $doms.length) {
                this.isCreateing = false
                this.folderToZip(images)
              }
            });
        })
      },
      folderToZip(images){
        let zip = new JSZip()
        let img = zip.folder("images");
        _.each(images,(item,index) => {
          img.file(item.name, item.blob,{type: "blob"});
        })
        zip.generateAsync({type:"blob"})
          .then(function(content) {
            fileSaver.saveAs(content, "sizesImage.zip");
          });
      }
    }
  }
</script>
<style lang="less" scoped>
  .size-info {
    margin-top: 65px;
  }
  .item-tag {
    padding: 2px 5px;
    border: 1px solid #333;
    cursor: pointer;
    margin-right: 5px;
  }
  .selected {
    border: 1px solid rgb(38, 103, 189);
    color: rgb(38, 103, 189);
  }
  .margin-right {
    margin-right: 5px;
  }
  .el-dropdown-menu {
    .file-btn {
      position: relative;
      input[type="file"] {
        position: absolute;
        top:0;
        left:0;
        width: 70px;
        height: 32px;
        opacity: 0;
      }
    }
  }
  .batch-export-size-img-page{
    .preview-container {
      padding-left: 10px;
      .size-img-swap {
        position: relative;
        display: inline-block;
        margin-left: 20px;
        margin-top: 20px;
        color:#666666;
        .size-img {
          width: 750px;
          background: #fff;
          padding: 0 20px 20px 0px;
          .new-props-swap {
            padding:0 50px;
            .props-title {
              display: inline-block;
              width: 50px;
              font-size: 22px;
              color: #000;
              margin-right: 10px;
            }
            .prop-item {
              font-size: 22px;
              color: #666;
              margin-right: 20px;
            }
            .color-swap {
              display: flex;
              margin-bottom: 32px;
              .color-item-swap {
                width: 600px;
              }
            }
            .props-group {
              .prop {
                float: left;
                display: flex;
                margin-bottom: 32px;
                &:nth-child(2n-1){
                  margin-right: 110px;
                }
                .prop-value-swap {
                  width: 200px;
                  padding-top: 20px;
                  border-top: 3px solid #F5F5F5;
                  display: flex;
                  justify-content: space-between;
                  position: relative;
                  top: 5px;
                  .prop-value {
                    position: relative;
                    font-size: 16px;
                    color: #999;
                    .line {
                      position: absolute;
                      top: -23px;
                      left: 0px;
                      width: 30px;
                      height:3px;
                      background-color: #999;
                    }
                    .active {
                      color: #333;
                    }
                  }
                }
              }
              .margin-bottom-0 {
                margin-bottom: 2px;
              }
            }
            .prop-tips {
              position: relative;
              font-size: 24px;
              padding-left: 20px;
              margin-top: 20px;
              text-align: center;
            }
          }
          .props {
            width: 100%;
            margin-bottom: 110px;
            .prop-item {
              min-width: 50%;
              float: left;
              font-size: 24px;
              padding-left: 20px;
              margin-bottom: 26px;
              &::before {
                content:'';
                display: inline-block;
                position: relative;
                top:-2px;
                margin-right: 10px;
                margin-top: 8px;
                width:12px;
                height: 12px;
                background: #333;
              }
            }
            .prop-tips {
              position: relative;
              font-size: 24px;
              padding-left: 20px;
              text-align: center;
              float: left;
            }
          }
          table {
            font-size: 22px;
            thead {
              td {
                padding-bottom: 23px;
                color: #000;
              }
            }
            tbody {
              td {
                padding-bottom: 23px;
                &:nth-child(2) {
                  color: #000;
                }
              }
            }
          }
          .tfoot {
            font-size: 22px;
            margin-top: 10px;
            text-align: right;
            color: #000;
          }
          .size-tips {
            font-size: 22px;
            margin-left: 20px;
            padding-top: 20px;
            text-align: center;
          }
        }
        .size-id {
          position: absolute;
          top:25px;
          left:30px;
          color:#000;
          z-index: 2;
        }
        .new-size {
          padding-top: 80px;
          .new-title {
            margin-top: 80px;
            margin-left: 40px;
            margin-bottom: 26px;
            font-size: 30px;
            font-family:PingFangSC-Semibold,PingFang SC;
            font-weight:600;
            color:rgba(0,0,0,1);
            line-height:44px;
            &:first-child {
              margin-top: 0;
              margin-left: 34px;
            }
          }
          .prop-item {
            font-size:28px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(102,102,102,1);
            line-height:40px;
            padding-left: 40px;
            padding-right: 40px;
          }
          table {
            thead {
              td {
                font-size: 26px;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                color:rgba(0,0,0,1);
                line-height:36px;
                padding-bottom: 24px;
              }
            }
            tbody {
              td {
                font-size:24px;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                color:rgba(102,102,102,1);
                line-height:34px;
                padding-bottom: 24px;
                &:nth-child(2) {
                  color:rgba(102,102,102,1);
                }
              }
            }
            tbody {
              td {
                padding-bottom: 23px;
                color:rgba(102,102,102,1);
                &:nth-child(2) {
                  color:rgba(102,102,102,1);
                }
              }
            }
          }
          .size-key {
            top: 15px;
          }
        }
      }
    }

  }
</style>
